// AppRemitoReactTable.jsx
import React, { useCallback, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { usePagination, useSortBy, useTable } from "react-table";

import {
  getRemitos,
  deleteRemito,
  getRemitoById,
} from "../helpers/rutaRemitos";

import ModalFormRemito from "../components/ModalFormRemito";
import ModalOrdenCobroRemito from "../components/ModalOrdenCobroRemito";
import ModalOrdenPagoRemito from "../components/ModalOrdenPagoRemito";
import { Modal } from "react-bootstrap";
import AppOrdenesRemitoReactTable from "../components/AppOrdenesRemitoReactTable";

const Styles = styled.div`
  .app-remitos-container {
    max-width: 1320px;
    margin: 0 auto;
  }

  .filter-box {
    width: 100%;
  }

  .table-wrap {
    width: 100%;
    overflow-x: auto;
    overflow-y: auto;
    max-height: 720px;
    border: 1px solid #999;
    background: #fff;
  }

  table {
    border-spacing: 0;
    width: max-content;
    min-width: 100%;
    table-layout: fixed;
    font-size: 12px;
  }

  th,
  td {
    padding: 6px;
    border-bottom: 1px solid #999;
    border-right: 1px solid #999;
    vertical-align: middle;
    white-space: nowrap;
  }

  th {
    position: sticky;
    top: 0;
    z-index: 3;
    background: #1f5fd1;
    color: #fff;
    text-align: center;
    font-size: 12px;
  }

  td {
    background: #fff;
  }

  tfoot td {
    position: sticky;
    bottom: 0;
    background: #f1f1f1;
    font-weight: bold;
    z-index: 2;
  }

  .action-cell {
    display: flex;
    justify-content: center;
    gap: 8px;
  }

  .action-btn {
    border: none;
    background: transparent;
    cursor: pointer;
    width: 28px;
    height: 28px;
    padding: 0;
    font-size: 17px;
    border-radius: 6px;
  }

  .action-btn--edit {
    color: #0d6efd;
  }

  .action-btn--del {
    color: #dc3545;
  }

  .action-btn--oc {
    color: #198754;
  }

  .action-btn--oc:hover:not(:disabled) {
    background: #e8f5ed;
  }

  .action-btn--op {
    color: #b7791f;
  }

  .action-btn--op:hover:not(:disabled) {
    background: #fff4df;
  }

  .action-btn:disabled {
    opacity: 0.35;
    cursor: default;
  }
  .num {
    text-align: right;
  }

  .center {
    text-align: center;
  }

  .left {
    text-align: left;
  }

  .filter-box {
    width: 100%;

    margin-bottom: 12px;

    padding: 14px;

    border: 1px solid #e2e8f0;
    border-radius: 12px;

    background: #ffffff;

    box-shadow:
      0 3px 14px
      rgba(15, 23, 42, 0.035);
  }

  .filter-box label,
  .filter-box .form-label {
    margin-bottom: 5px;

    color: #59687d;

    font-size: 10px !important;
    font-weight: 600;

    white-space: nowrap;
  }

  .filter-box input,
  .filter-box select,
  .filter-box .form-control {
    height: 34px;

    padding: 0 8px;

    border: 1px solid #d7e0ea;
    border-radius: 7px;

    background: #ffffff;

    color: #24324a;

    font-size: 10.5px !important;
  }

  .filter-box input:focus,
  .filter-box select:focus,
  .filter-box .form-control:focus {
    border-color: #c0a678;

    box-shadow:
      0 0 0 2px
      rgba(141, 107, 54, 0.07);
  }

  .filter-box button {
    height: 34px;

    padding: 5px 9px;

    border-radius: 7px !important;

    font-size: 10px !important;

    font-weight: 600;
  }

  .filter-box .row {
    row-gap: 8px;
  }

  .remitos-total-registros {
    margin-bottom: 8px;

    padding: 6px 10px;

    border: 1px solid #e7ecf2;
    border-radius: 7px;

    background: #f8fafc;

    color: #718096;

    font-size: 10px;
  }

  .pagination-box {
    min-height: 48px;

    display: flex;
    align-items: center;

    gap: 6px;

    padding: 8px 12px;

    border-top: 1px solid #e5eaf0;

    background: #fbfcfe;

    color: #68778b;

    font-size: 10px;
    font-weight: 500;
  }

  .pagination-box button {
    min-width: 30px;
    height: 29px;

    padding: 0 7px;

    border: 1px solid #d3dce7;
    border-radius: 6px;

    background: #ffffff;

    color: #53657d;

    font-size: 10px;

    cursor: pointer;
  }

  .pagination-box button:hover:not(:disabled) {
    border-color: #c0a678;

    background: #fdfaf5;

    color: #80602f;
  }

  .pagination-box button:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

const InformeRemitosHeader = styled.div`
  display: flex;
  align-items: center;

  min-height: 78px;

  margin-bottom: 12px;

  padding: 14px 18px;

  border: 1px solid #e5dcc9;
  border-radius: 14px;

  background:
    linear-gradient(
      120deg,
      #ffffff 0%,
      #fdfbf7 65%,
      #f8f2e7 100%
    );

  box-shadow:
    0 3px 14px
    rgba(15, 23, 42, 0.035);

  .header-icon {
    width: 46px;
    height: 46px;

    flex: 0 0 46px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 13px;

    border-radius: 11px;

    background: #f5eddf;

    color: #8d6b36;

    font-size: 19px;
  }

  .header-text span {
    display: block;

    margin-bottom: 2px;

    color: #987746;

    font-size: 9px;
    font-weight: 700;

    letter-spacing: 1.7px;
  }

  .header-text h3 {
    margin: 0 0 3px 0;

    color: #18243a;

    font-size: 20px;
    font-weight: 700;
  }

  .header-text p {
    margin: 0;

    color: #748196;

    font-size: 10px;
  }

  @media (max-width: 768px) {
    padding: 12px;

    .header-icon {
      width: 42px;
      height: 42px;
      flex-basis: 42px;
    }

    .header-text h3 {
      font-size: 17px;
    }
  }
`;

const fmtMoney = (n) =>
  Number(n || 0).toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const fmtKg = (n) =>
  Number(n || 0).toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const fmtDate = (value) => {
  if (!value) return "-";

  const s = String(value);

  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const [y, m, d] = s.slice(0, 10).split("-");
    return `${d}/${m}/${y}`;
  }

  const d = new Date(value);

  if (Number.isNaN(d.getTime())) return "-";

  const yyyy = d.getUTCFullYear();
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(d.getUTCDate()).padStart(2, "0");

  return `${dd}/${mm}/${yyyy}`;
};

const dateISO = (value) => {
  if (!value) return "";

  const s = String(value);

  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);

  const d = new Date(value);

  if (Number.isNaN(d.getTime())) return "";

  const yyyy = d.getUTCFullYear();
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(d.getUTCDate()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}`;
};

const norm = (v) =>
  String(v ?? "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();

const safeGet = (obj, path) => {
  try {
    return (
      path.split(".").reduce((o, k) => {
        if (o && o[k] !== undefined && o[k] !== null) return o[k];
        return "";
      }, obj) || ""
    );
  } catch {
    return "";
  }
};

const getNombreProveedor = (r) =>
  safeGet(r, "proveedor.razonsocial") ||
  safeGet(r, "proveedor.nombre") ||
  safeGet(r, "proveedor.proveedor") ||
  "";

const getNombreCliente = (r) =>
  safeGet(r, "cliente.razonsocial") ||
  safeGet(r, "cliente.nombre") ||
  safeGet(r, "cliente.cliente") ||
  "";

const getNombreTransporte = (r) =>
  safeGet(r, "transporte.transporte") ||
  safeGet(r, "transporte.razonsocial") ||
  safeGet(r, "transporte.nombre") ||
  "";

const getNombreChofer = (r) =>
  safeGet(r, "chofer.nombre") ||
  safeGet(r, "chofer.chofer") ||
  "";

const getNroViaje = (r) =>
  r?.nroviaje || r?.nroViaje || "";

const normalizarRemitos = (resp) => {
  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp?.remitos)) return resp.remitos;
  if (Array.isArray(resp?.data?.remitos)) return resp.data.remitos;
  if (Array.isArray(resp?.data)) return resp.data;
  return [];
};

const sumRows = (rows, field) =>
  rows.reduce((acc, row) => acc + Number(row.original?.[field] || 0), 0);

const AppRemitoReactTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [remitoSel, setRemitoSel] = useState(null);
  const [showModalEdit, setShowModalEdit] = useState(false);

  const [showOC, setShowOC] = useState(false);
  const [clienteCobro, setClienteCobro] = useState(null);

  const [showOP, setShowOP] = useState(false);
  const [proveedorPago, setProveedorPago] = useState(null);

  const [listadoOrdenes, setListadoOrdenes] = useState(null);

  const [filtros, setFiltros] = useState({
    desde: "",
    hasta: "",
    proveedor: "",
    cliente: "",
    chofer: "",
    viaje: "",
    remDesde: "",
    remHasta: "",
  });

  const setF = (key, value) => {
    setFiltros((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const limpiarFiltros = () => {
    setFiltros({
      desde: "",
      hasta: "",
      proveedor: "",
      cliente: "",
      chofer: "",
      viaje: "",
      remDesde: "",
      remHasta: "",
    });
  };

  const fetchData = useCallback(async () => {
    setLoading(true);

    try {
      const resp = await getRemitos();
      const lista = normalizarRemitos(resp);

      lista.sort((a, b) => {
        const codA = Number(a?.codrem || 0);
        const codB = Number(b?.codrem || 0);

        if (codB !== codA) return codB - codA;

        return new Date(b?.fecha || 0) - new Date(a?.fecha || 0);
      });

      setData(lista);
    } catch (error) {
      console.error("❌ Error al cargar remitos:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const abrirEditar = useCallback(async (remito) => {
    try {
      const resp = await getRemitoById(remito._id);
      const doc = resp?.remito || resp;

      if (!doc?._id) {
        alert("No se pudo cargar el remito.");
        return;
      }

      setRemitoSel(doc);
      setShowModalEdit(true);
    } catch (error) {
      console.error("❌ Error getRemitoById:", error);
      alert("No se pudo abrir el remito.");
    }
  }, []);

  const cerrarEditar = () => {
    setShowModalEdit(false);
    setRemitoSel(null);
    fetchData();
  };

  const borrar = useCallback(
    async (id) => {
      if (!window.confirm("¿Eliminar este remito?")) return;

      try {
        const resp = await deleteRemito(id);

        if (resp?.ok === false) {
          const msg =
            resp?.err?.message ||
            resp?.error?.err?.message ||
            resp?.error?.message ||
            resp?.error ||
            "No se pudo eliminar el remito.";

          alert(typeof msg === "string" ? msg : "No se pudo eliminar el remito.");
          return;
        }

        fetchData();
      } catch (error) {
        console.error("❌ Error deleteRemito:", error);
        alert("No se pudo eliminar el remito.");
      }
    },
    [fetchData]
  );

  const dataFiltrada = useMemo(() => {
    const remDesde =
      filtros.remDesde !== "" ? Number(filtros.remDesde) : null;

    const remHasta =
      filtros.remHasta !== "" ? Number(filtros.remHasta) : null;

    return (data || []).filter((r) => {
      const fISO = dateISO(r?.fecha);

      if (filtros.desde && (!fISO || fISO < filtros.desde)) return false;
      if (filtros.hasta && (!fISO || fISO > filtros.hasta)) return false;

      const proveedor = getNombreProveedor(r);
      const cliente = getNombreCliente(r);
      const chofer = getNombreChofer(r);
      const viaje = getNroViaje(r);

      if (
        filtros.proveedor &&
        !norm(proveedor).includes(norm(filtros.proveedor))
      ) {
        return false;
      }

      if (filtros.cliente && !norm(cliente).includes(norm(filtros.cliente))) {
        return false;
      }

      if (filtros.chofer && !norm(chofer).includes(norm(filtros.chofer))) {
        return false;
      }

      if (filtros.viaje && !norm(viaje).includes(norm(filtros.viaje))) {
        return false;
      }

      const cod = Number(r?.codrem || 0);

      if (remDesde !== null && cod < remDesde) return false;
      if (remHasta !== null && cod > remHasta) return false;

      return true;
    });
  }, [data, filtros]);

  const abrirCobro = useCallback((remito) => {
    const cliente = remito?.cliente;
    const clienteId =
      typeof cliente === "string" ? cliente : cliente?._id;

    if (!clienteId) {
      window.alert("Este remito no tiene un cliente asociado.");
      return;
    }

    setClienteCobro(cliente);
    setShowOC(true);
  }, []);

  const cerrarCobro = (guardada = false) => {
    setShowOC(false);
    setClienteCobro(null);

    if (guardada) {
      fetchData();
    }
  };

  const abrirPago = useCallback((remito) => {
    const proveedor = remito?.proveedor;
    const proveedorId =
      typeof proveedor === "string" ? proveedor : proveedor?._id;

    if (!proveedorId) {
      window.alert("Este remito no tiene un proveedor asociado.");
      return;
    }

    setProveedorPago(proveedor);
    setShowOP(true);
  }, []);

  const cerrarPago = (guardada = false) => {
    setShowOP(false);
    setProveedorPago(null);

    if (guardada) {
      fetchData();
    }
  }; 

  const columns = useMemo(
    () => [
      {
        Header: "Edita",
        id: "edit",
        width: 60,
        Cell: ({ row }) => (
          <div className="action-cell">
            <button
              type="button"
              className="action-btn action-btn--edit"
              title="Editar remito"
              onClick={() => abrirEditar(row.original)}
            >
              <i className="fa fa-pencil" aria-hidden="true" />
            </button>
          </div>
        ),
      },
      {
        Header: "Borra",
        id: "delete",
        width: 60,
        Cell: ({ row }) => (
          <div className="action-cell">
            <button
              type="button"
              className="action-btn action-btn--del"
              title="Eliminar remito"
              onClick={() => borrar(row.original._id)}
            >
              <i className="fa fa-trash" aria-hidden="true" />
            </button>
          </div>
        ),
      },
      {
        Header: "OC",
        id: "cobrar",
        width: 60,
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="action-cell">
            <button
              type="button"
              className="action-btn action-btn--oc"
              onClick={() => abrirCobro(row.original)}
              disabled={!row.original.cliente}
              title="Crear orden de cobro de papas"
              aria-label="Crear orden de cobro de papas"
            >
              <i className="fa fa-money" aria-hidden="true" />
            </button>
          </div>
        ),
      },
      {
        Header: "OP",
        id: "pagar",
        width: 60,
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="action-cell">
            <button
              type="button"
              className="action-btn action-btn--op"
              onClick={() => abrirPago(row.original)}
              disabled={!row.original.proveedor}
              title="Crear orden de pago de papas"
              aria-label="Crear orden de pago de papas"
            >
              <i className="fa fa-credit-card" aria-hidden="true" />
            </button>
          </div>
        ),
      },
      {
        Header: "Remito",
        accessor: "codrem",
        width: 90,
        Cell: ({ value }) => <div className="center">{value || "-"}</div>,
      },
      {
        Header: "Fecha",
        id: "fecha",
        width: 110,
        accessor: (row) => row.fecha,
        Cell: ({ value }) => <div className="center">{fmtDate(value)}</div>,
      },
      {
        Header: "Nro Viaje",
        id: "nroviaje",
        width: 110,
        accessor: (row) => getNroViaje(row),
        Cell: ({ value }) => <div className="center">{value || "-"}</div>,
      },
      {
        Header: "Proveedor",
        id: "proveedor",
        width: 240,
        accessor: (row) => getNombreProveedor(row),
        Cell: ({ value }) => <div className="left">{value || "-"}</div>,
      },
      {
        Header: "Cliente",
        id: "cliente",
        width: 240,
        accessor: (row) => getNombreCliente(row),
        Cell: ({ value }) => <div className="left">{value || "-"}</div>,
      },
      {
        Header: "Chofer",
        id: "chofer",
        width: 180,
        accessor: (row) => getNombreChofer(row),
        Cell: ({ value }) => <div className="left">{value || "-"}</div>,
      },
      {
        Header: "Transporte",
        id: "transporte",
        width: 180,
        accessor: (row) => getNombreTransporte(row),
        Cell: ({ value }) => <div className="left">{value || "-"}</div>,
      },
      {
        Header: "Variedad",
        accessor: "variedad",
        width: 140,
        Cell: ({ value }) => <div className="left">{value || "-"}</div>,
      },
      {
        Header: "KG Campo",
        accessor: "kgCampo",
        width: 110,
        Cell: ({ value }) => <div className="num">{fmtKg(value)}</div>,
        Footer: ({ rows }) => (
          <div className="num">{fmtKg(sumRows(rows, "kgCampo"))}</div>
        ),
      },
      {
        Header: "KG Recib.",
        accessor: "kgRecibido",
        width: 110,
        Cell: ({ value }) => <div className="num">{fmtKg(value)}</div>,
        Footer: ({ rows }) => (
          <div className="num">{fmtKg(sumRows(rows, "kgRecibido"))}</div>
        ),
      },
      {
        Header: "Dif.",
        accessor: "diferencia",
        width: 100,
        Cell: ({ value }) => <div className="num">{fmtKg(value)}</div>,
        Footer: ({ rows }) => (
          <div className="num">{fmtKg(sumRows(rows, "diferencia"))}</div>
        ),
      },
      {
        Header: "Precio Compra",
        accessor: "precioCompra",
        width: 130,
        Cell: ({ value }) => <div className="num">$ {fmtMoney(value)}</div>,
      },
      {
        Header: "Precio Venta",
        accessor: "precioVenta",
        width: 130,
        Cell: ({ value }) => <div className="num">$ {fmtMoney(value)}</div>,
      },
      {
        Header: "% Compra B",
        accessor: "porcentajeCompra",
        width: 110,
        Cell: ({ value }) => (
          <div className="center">{Number(value || 0).toFixed(0)} %</div>
        ),
      },
      {
        Header: "% Venta B",
        accessor: "porcentajeVenta",
        width: 110,
        Cell: ({ value }) => (
          <div className="center">{Number(value || 0).toFixed(0)} %</div>
        ),
      },
      {
        Header: "Compra A",
        accessor: "totalCompraA",
        width: 130,
        Cell: ({ value }) => <div className="num">$ {fmtMoney(value)}</div>,
        Footer: ({ rows }) => (
          <div className="num">$ {fmtMoney(sumRows(rows, "totalCompraA"))}</div>
        ),
      },
      {
        Header: "Compra B",
        accessor: "totalCompraB",
        width: 130,
        Cell: ({ value }) => <div className="num">$ {fmtMoney(value)}</div>,
        Footer: ({ rows }) => (
          <div className="num">$ {fmtMoney(sumRows(rows, "totalCompraB"))}</div>
        ),
      },
      {
        Header: "Total Compra",
        accessor: "totalCompra",
        width: 140,
        Cell: ({ value }) => <div className="num">$ {fmtMoney(value)}</div>,
        Footer: ({ rows }) => (
          <div className="num">$ {fmtMoney(sumRows(rows, "totalCompra"))}</div>
        ),
      },
      {
        Header: "Venta A",
        accessor: "totalVentaA",
        width: 130,
        Cell: ({ value }) => <div className="num">$ {fmtMoney(value)}</div>,
        Footer: ({ rows }) => (
          <div className="num">$ {fmtMoney(sumRows(rows, "totalVentaA"))}</div>
        ),
      },
      {
        Header: "Venta B",
        accessor: "totalVentaB",
        width: 130,
        Cell: ({ value }) => <div className="num">$ {fmtMoney(value)}</div>,
        Footer: ({ rows }) => (
          <div className="num">$ {fmtMoney(sumRows(rows, "totalVentaB"))}</div>
        ),
      },
      {
        Header: "Total Venta",
        accessor: "totalVenta",
        width: 140,
        Cell: ({ value }) => <div className="num">$ {fmtMoney(value)}</div>,
        Footer: ({ rows }) => (
          <div className="num">$ {fmtMoney(sumRows(rows, "totalVenta"))}</div>
        ),
      },
      {
        Header: "Comisión",
        accessor: "comision",
        width: 130,
        Cell: ({ value }) => <div className="num">$ {fmtMoney(value)}</div>,
        Footer: ({ rows }) => (
          <div className="num">$ {fmtMoney(sumRows(rows, "comision"))}</div>
        ),
      },
      {
        Header: "Flete",
        accessor: "flete",
        width: 120,
        Cell: ({ value }) => <div className="num">$ {fmtMoney(value)}</div>,
        Footer: ({ rows }) => (
          <div className="num">$ {fmtMoney(sumRows(rows, "flete"))}</div>
        ),
      },
      {
        Header: "DTV Compra",
        accessor: "nroDTVCompra",
        width: 150,
        Cell: ({ value }) => <div className="left">{value || "-"}</div>,
      },
      {
        Header: "DTV Venta",
        accessor: "nroDTVVenta",
        width: 150,
        Cell: ({ value }) => <div className="left">{value || "-"}</div>,
      },
      {
        Header: "Factura Compra",
        accessor: "facturacompra",
        width: 150,
        Cell: ({ value }) => <div className="left">{value || "-"}</div>,
      },
      {
        Header: "Factura Venta",
        accessor: "facturaventa",
        width: 150,
        Cell: ({ value }) => <div className="left">{value || "-"}</div>,
      },
      {
        Header: "Flete Cta.",
        accessor: "factura",
        width: 100,
        Cell: ({ value }) => <div className="center">{value ? "Sí" : "No"}</div>,
      },
      {
        Header: "Nota",
        accessor: "nota",
        width: 360,
        Cell: ({ value }) => <div className="left">{value || "-"}</div>,
      },
    ],
    [abrirEditar, borrar, abrirCobro, abrirPago]
  );

  const tableInstance = useTable(
    {
      columns,
      data: dataFiltrada,
      initialState: {
        pageSize: 20,
        sortBy: [{ id: "codrem", desc: true }],
      },
    },
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
  } = tableInstance;

  if (loading) {
    return <div className="p-3">Cargando remitos...</div>;
  }

  return (
    <Styles>
      <div className="container mt-4 app-remitos-container">

        <InformeRemitosHeader>
          <div className="header-icon">
            <i
              className="fa fa-file-text-o"
              aria-hidden="true"
            />
          </div>

          <div className="header-text">
            <span>
              INFORMES · PAPAS
            </span>

            <h3>
              Listado de Remitos
            </h3>

            <p>
              Consulta y control de remitos,
              proveedores, clientes, kilos,
              precios y documentación.
            </p>
          </div>
        </InformeRemitosHeader>

        <div className="d-flex flex-wrap gap-2 mb-3">
          <button
            type="button"
            className="btn btn-outline-success btn-sm"
            onClick={() => setListadoOrdenes("OC")}
          >
            <i className="fa fa-money mr-1" aria-hidden="true" /> Ver OC
          </button>

          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={() => setListadoOrdenes("OP")}
          >
            <i className="fa fa-credit-card mr-1" aria-hidden="true" /> Ver OP
          </button>
        </div>

        <div className="filter-box">
          <div className="row g-2 align-items-end">
            <div className="col-sm-2">
              <label className="form-label">Fecha desde</label>
              <input
                type="date"
                className="form-control"
                value={filtros.desde}
                onChange={(e) => setF("desde", e.target.value)}
              />
            </div>

            <div className="col-sm-2">
              <label className="form-label">Fecha hasta</label>
              <input
                type="date"
                className="form-control"
                value={filtros.hasta}
                onChange={(e) => setF("hasta", e.target.value)}
              />
            </div>

            <div className="col-sm-2">
              <label className="form-label">Remito desde</label>
              <input
                type="number"
                className="form-control"
                value={filtros.remDesde}
                onChange={(e) => setF("remDesde", e.target.value)}
              />
            </div>

            <div className="col-sm-2">
              <label className="form-label">Remito hasta</label>
              <input
                type="number"
                className="form-control"
                value={filtros.remHasta}
                onChange={(e) => setF("remHasta", e.target.value)}
              />
            </div>

            <div className="col-sm-2">
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={limpiarFiltros}
              >
                Limpiar filtros
              </button>
            </div>

            <div className="col-sm-2">
              <button
                type="button"
                className="btn btn-dark w-100"
                onClick={fetchData}
              >
                Actualizar
              </button>
            </div>
          </div>

        <div className="row g-2 align-items-end mt-2">
          <div className="col-sm">
            <label className="form-label">Proveedor</label>
            <input
              className="form-control"
              value={filtros.proveedor}
              onChange={(e) => setF("proveedor", e.target.value)}
            />
          </div>

          <div className="col-sm">
            <label className="form-label">Cliente</label>
            <input
              className="form-control"
              value={filtros.cliente}
              onChange={(e) => setF("cliente", e.target.value)}
            />
          </div>

          <div className="col-sm">
            <label className="form-label">Chofer</label>
            <input
              className="form-control"
              value={filtros.chofer}
              onChange={(e) => setF("chofer", e.target.value)}
            />
          </div>

          <div className="col-sm">
            <label className="form-label">Nro Viaje</label>
            <input
              className="form-control"
              value={filtros.viaje}
              onChange={(e) => setF("viaje", e.target.value)}
              placeholder="Ej: 1301,1"
            />
          </div>

          <div className="col-sm">
            <label className="form-label">Registros</label>
            <select
              className="form-control"
              value={state.pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
            >
              {[10, 20, 50, 100].map((size) => (
                <option key={size} value={size}>
                  Mostrar {size}
                </option>
              ))}
            </select>
          </div>
        </div>
        </div>

        <div className="remitos-total-registros">
          Mostrando{" "}
          <strong>{dataFiltrada.length}</strong>{" "}
          remitos
        </div>

        <div className="table-wrap">
          <table {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      style={{
                        width: column.width || 120,
                        minWidth: column.width || 120,
                      }}
                    >
                      {column.render("Header")}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody {...getTableBodyProps()}>
              {page.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} className="center">
                    No hay remitos para mostrar.
                  </td>
                </tr>
              ) : (
                page.map((row) => {
                  prepareRow(row);

                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => (
                        <td
                          {...cell.getCellProps()}
                          style={{
                            width: cell.column.width || 120,
                            minWidth: cell.column.width || 120,
                          }}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })
              )}
            </tbody>

            <tfoot>
              {footerGroups.map((footerGroup) => (
                <tr {...footerGroup.getFooterGroupProps()}>
                  {footerGroup.headers.map((column) => (
                    <td
                      {...column.getFooterProps()}
                      style={{
                        width: column.width || 120,
                        minWidth: column.width || 120,
                      }}
                    >
                      {column.Footer ? column.render("Footer") : ""}
                    </td>
                  ))}
                </tr>
              ))}
            </tfoot>
          </table>
        </div>

        <div className="pagination-box">
          <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            {"<<"}
          </button>

          <button onClick={() => previousPage()} disabled={!canPreviousPage}>
            {"<"}
          </button>

          <span>
            Página{" "}
            <strong>
              {state.pageIndex + 1} de {pageOptions.length || 1}
            </strong>
          </span>

          <button onClick={() => nextPage()} disabled={!canNextPage}>
            {">"}
          </button>

          <button
            onClick={() => gotoPage(pageOptions.length - 1)}
            disabled={!canNextPage}
          >
            {">>"}
          </button>
        </div>

         {listadoOrdenes && (
          <Modal
            show
            onHide={() => setListadoOrdenes(null)}
            size="xl"
            scrollable
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {listadoOrdenes === "OC"
                  ? "Órdenes de cobro · Papas"
                  : "Órdenes de pago · Papas"}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <AppOrdenesRemitoReactTable
                key={listadoOrdenes}
                tipo={listadoOrdenes}
              />
            </Modal.Body>
          </Modal>
        )}     

        {showModalEdit && remitoSel && (
          <ModalFormRemito
            show={showModalEdit}
            remito={remitoSel}
            onClose={cerrarEditar}
            handleClose={cerrarEditar}
            onSaved={cerrarEditar}
          />
        )}

        {showOC && clienteCobro && (
          <ModalOrdenCobroRemito
            show={showOC}
            cliente={clienteCobro}
            onHide={cerrarCobro}
          />
        )}

        {showOP && proveedorPago && (
          <ModalOrdenPagoRemito
            show={showOP}
            proveedor={proveedorPago}
            onHide={cerrarPago}
          />
        )}

      </div>
    </Styles>
  );
};

export default AppRemitoReactTable;